import { isEmpty } from 'lodash';
import { apiCheckResourceAvailability, apiShareRequestAccess } from '../../../../helpers/api';
import { dispatcher } from '../../../../helpers/projectHelper';
import { successToast } from '../../../../helpers/toastHelper';
import { forceCloseCurator } from '../../../../helpers/unityHelper';
import { curatorMissingDataActions, selectExpiredTextureList, selectMissingHdriList, selectMissingMaterialList, selectMissingPropList, selectMissingTextureList, setExpiredTextureList } from '../../../../redux/slicers/admin/curatorMissingDataSlicer';
import { selectIndividualProjectData } from '../../../../redux/slicers/admin/curatorSlicer';
import { infoDialogActions } from '../../../../redux/slicers/infoDialogSlicer';
import { getAppState } from '../../../../redux/store';
import { navigateToAddOns } from '../../../../screens/subscriptionComponents/subscriptionHelper';
import { setDraggablePropLoading } from '../../../../redux/slicers/admin/curatorLoaderSlicer';
import { cancelDraggablePropUI } from '../../../../api/useUnityProp';
import { Mixpanel, MxEvent } from '../../../../common/Mixpanel';
import { getMattressBuilderPath } from '../../../../helpers/urlHelper';
import { isMattressBuilderPage } from '../../../../components/admin/curator/ProductBuilderComponents/commonHelper';

export const handleMissingCuratorDetails = async (isProductSection) => {
  const appState = getAppState();
  const missingProps = selectMissingPropList(appState); // props data is fetched earlier
  const missingMaterialsData = selectMissingMaterialList(appState);
  let missingTexturesData = selectMissingTextureList(appState);
  const missingHdriData = selectMissingHdriList(appState);

  const params = new URLSearchParams(window.location.search);
  const isFromProductPage = params.get('isFromProductPage');
  const isFromProductPageValue = isFromProductPage === true || isFromProductPage === 'true';

  // missingTexturesData = [{ id: ??? }]


  // for materials data like exist or need access we need to fetch it first
  let { missingMaterials, missingTextures, missingHdris } = await fetchMissingData(missingMaterialsData, missingTexturesData, missingHdriData);

  // missingTextures = [{
  //   "id": ????,
  //   "name": "test share",
  //   "old_texture_id": null,
  //   "is_available": false,
  //   "is_exist": true
  // }]


  const filterMissingInDatabase = (list) => removeMissingDuplicates(list.filter((p) => !p.is_exist))
  const missingInDatabaseProps = filterMissingInDatabase(missingProps);
  const missingInDatabaseTextures = filterMissingInDatabase(missingTextures);
  const missingInDatabaseMaterials = filterMissingInDatabase(missingMaterials);
  const missingInDatabaseHdris = filterMissingInDatabase(missingHdris);
  const notExistList = [
    {
      label: 'Props',
      items: missingInDatabaseProps,
    },
    {
      label: 'Materials',
      items: missingInDatabaseMaterials,
    },
    {
      label: 'Textures',
      items: isFromProductPageValue ? [] : missingInDatabaseTextures,
    },
    {
      label: 'Hdri',
      items: missingInDatabaseHdris,
    },
  ];
  
  await showDataDoesNotExistDialog({ list: notExistList, isProductSection:isProductSection });

  const filterMissingPermissions = (list) => removeMissingDuplicates(list.filter((p) => !p.is_available && p.is_exist));
  const missingPermissionsProps = filterMissingPermissions(missingProps)
  const missingPermissionsTextures = filterMissingPermissions(missingTextures)
  const missingPermissionsMaterials = filterMissingPermissions(missingMaterials)

  const missingPermissionsHdris = filterMissingPermissions(missingHdris)
  const missingPermissionList = [
    {
      label: 'Props',
      apiKey: 'product',
      items: missingPermissionsProps,
    },
    {
      label: 'Materials',
      apiKey: 'material',
      items: missingPermissionsMaterials,
    },
    {
      label: 'Textures',
      apiKey: 'texture',
      items: isFromProductPageValue ? [] : missingPermissionsTextures,
    },
    {
      label: 'Hdri',
      apiKey: 'hdri',
      items: missingPermissionsHdris,
    },
  ];

  await showMissingPermissionsDialog({ list: missingPermissionList, isProductSection: isProductSection });

  // showing modal of expired textures list
  const expiredTextureList = selectExpiredTextureList(appState);
  await showExpiredTexturesDataDialog({ list: [{
    label: 'Textures',
    apiKey: 'texture',
    items: expiredTextureList
  }], isProductSection: isProductSection })

  dispatcher(curatorMissingDataActions.resetState())
};


const showExpiredTexturesDataDialog = async ({ list, isProductSection }) => {

  const hasExpiredData = list.find((item) => item.items.length > 0);
  if (hasExpiredData && isProductSection){
    setDraggablePropLoading(false);
    cancelDraggablePropUI();
  }
  if (!hasExpiredData) return;

  await new Promise((resolve) => {
    dispatcher(
      infoDialogActions.openInfoDialog({
        title: 'Expired!!',
        description: (
          <>
            Some of the requested texture{list.length > 1 ? 's are' : ' is'} expired:
            <br />
            <MissingDataList list={list} />
          </>
        ),
        cancelButtonText: 'Cancel',
        buttonText: 'Buy now',
        backdrop: 'static',
        dispatch: dispatcher,
        dialogClassName: 'modal-dialog-curator-missing-data',
        onClose: () => resolve(),
        onCancelClick: () => resolve(),
        onButtonClick: () => navigateToAddOns({ newTab: true }),
      })
    );
  });
};

const showDataDoesNotExistDialog = async ({ list, isProductSection }) => {
  const hasMissingData = list.find((item) => item.items.length > 0);
  if (hasMissingData && isProductSection){
    setDraggablePropLoading(false);
    cancelDraggablePropUI();
  }
  if (!hasMissingData) return;

  await new Promise((resolve) => {
    dispatcher(
      infoDialogActions.openInfoDialog({
        title: 'Missing data!!',
        description: (
          <>
            Some of the requested data is missing:
            <br />
            <MissingDataList list={list} />
          </>
        ),
        cancelButtonText: 'Skip & continue',
        buttonText: 'Cancel',
        backdrop: 'static',
        dispatch: dispatcher,
        dialogClassName: 'modal-dialog-curator-missing-data',
        onClose: () => resolve(),
        onCancelClick: () => resolve(),
        onButtonClick: () => forceCloseCurator({ url: isMattressBuilderPage() ? getMattressBuilderPath() : null }),
      })
    );
  });
};

const showMissingPermissionsDialog = async ({ list , isProductSection }) => {
  const hasMissingData = list.find((item) => item.items.length > 0);
  if(hasMissingData && isProductSection){
    setDraggablePropLoading(false);
    cancelDraggablePropUI();
  }
  if (!hasMissingData) return;

  await new Promise((resolve, reject) => {
    const handleRequestSuccess = () => {
      successToast('Request sent to the support team', 'Request sent');
      resolve('');
    };

    const handleSkipAndContinue = () => {
      resolve('');
      if (isProductSection) {
        Mixpanel.track(true, MxEvent.PG_ACCESS_REQUEST, {
          pg_skip_permission: isProductSection,
        });
      }
    };

    dispatcher(
      infoDialogActions.openInfoDialog({
        title: 'Hold on !',
        description: (
          <>
            Your organization does not have access of these files.
            <br />
            <MissingDataList list={list} />
          </>
        ),
        cancelButtonText: 'Skip & continue',
        buttonText: 'Request Access',
        dispatch: dispatcher,
        backdrop: 'static',
        dialogClassName: 'modal-dialog-curator-missing-data',
        onClose: () => resolve(''),
        onCancelClick: () => handleSkipAndContinue(),
        onButtonClick: async () => {
          const projectId = selectIndividualProjectData(getAppState());
          const payload = { is_curator: true };

          if (projectId) {
            payload.curator_project_id = projectId;
          }

          list.forEach(item => {
            if (!item.items.length) return;
            payload[item.apiKey] = item.items.map(i => i.id);
          })


          const result = await apiShareRequestAccess(payload);

          if (result?.status === true) {
            handleRequestSuccess();
            if (isProductSection) {
              Mixpanel.track(true, MxEvent.PG_ACCESS_REQUEST, {
                pg_request: isProductSection,
              });
            }
          }
        },
      })
    );
  });
};

const MissingDataList = ({ list }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', fontSize: 16, marginTop: 8 }}>
      <div>
        {list.map((item) => {
          if (!item.items.length) return null;
          
          const names = item.items.map((p) => p.name || 'UNKNOWN');

          return (
            <div key={item.label}>
              <span style={{ fontWeight: 400 }}>{item.label}</span> : <span>{names.join(', ')}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};


const fetchMissingData = async (materials, textures, hdri) => {
  const notMissingMaterials = materials.filter(id => id !== 'MISSING');
  const newMaterials = notMissingMaterials.filter(m => !m.oldId)
  const oldMaterials = notMissingMaterials.filter(m => m.oldId)

  const materialIdList = newMaterials.map(m => m.id).filter(Boolean);
  const oldMaterialIdList = oldMaterials.map(m => parseInt(m.oldId)).filter(Boolean);
  const textureIdList = textures.map(t => t.id).filter(id => id !== 'MISSING');
  const hdriIdList = hdri.map(h => h.id).filter(id => id !== 'MISSING');

  let missingMaterials = [...materials];
  let missingTextures = [...textures];
  let missingHdris = [...hdri];

  const params = new URLSearchParams(window.location.search);
  const isFromProductPage = params.get('isFromProductPage');
  const isFromProductPageValue = isFromProductPage === true || isFromProductPage === 'true';

  if (isEmpty(materialIdList) && isEmpty(oldMaterialIdList) && isEmpty(textureIdList) && isEmpty(hdriIdList)) {
    return { missingMaterials, missingTextures, missingHdris }
  }

  const result = await apiCheckResourceAvailability({ materialIdList, oldMaterialIdList, textureIdList, hdriIdList })

  if (result?.data?.MaterialV3) {
    const missingMaterialsNew = newMaterials.map(material => {
      const fetchedData = result.data.MaterialV3.find(d => {
        return d.id === parseInt(material.id)
      })
      return fetchedData || material;
    })

    const missingMaterialsOld = oldMaterials.map(material => {
      const fetchedData = result.data.MaterialV3.find(d => {
        return `${material.oldId}` === `${d.old_material_id}`;
      })
      return fetchedData || material;
    })

    missingMaterials = [...missingMaterialsNew, ...missingMaterialsOld];
  }

  if(isFromProductPageValue) {
    missingTextures = textures;
  } else {
    if (result?.data?.TexturesV3) {
      missingTextures = textures.map(texture => {
        const fetchedData = result.data.TexturesV3.find(d => d.id === parseInt(texture.id));
        return fetchedData || texture;
      })
    }
  }

  if (result?.data?.EnvironmentLight) {
    missingHdris = hdri.map(hdri => {
      const fetchedData = result.data.EnvironmentLight.find(d => d.id === parseInt(hdri.id));
      return fetchedData || hdri;
    })
  }

  return {
    missingMaterials,
    missingTextures,
    missingHdris
  }  
}


function removeMissingDuplicates(items) {
  const map = {}
  Object.values(items).map(item => {
    const key = item.oldId ? `oldId_${item.oldId}` : `id_${item.id}`
    map[key] = item;
  })

  return Object.values(map);
}